<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para1"><a id="page_iv"></a>This is a work of fiction. All of the characters, organizations, and events portrayed in this<br/>novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="para"> </p>
<p class="center-para"><span class="smallcaps">THOMAS DUNNE BOOKS</span>.<br/>An imprint of St. Martin’s Press.</p>
<p class="para"> </p>
<p class="center-para"><span class="smallcaps">TO TRY MEN’S SOULS</span>. Copyright © 2009 by Newt Gingrich and William R. Forstchen.<br/>All rights reserved. Printed in the United States of America.<br/>For information, address St. Martin’s Press, 175 Fifth Avenue,<br/>New York, N.Y. 10010.</p>
<p class="para"> </p>
<p class="center-para"><a href="http://www.thomasdunnebooks.com" target="_blank">www.thomasdunnebooks.com</a></p>
<p class="para"> </p>
<p class="center-para"><a href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="para"> </p>
<p class="center-para"><em>Book design by Jonathan Bennett</em></p>
<p class="para"> </p>
<p class="center-para">Library of Congress Cataloging-in-Publication Data</p>
<p class="para"> </p>
<p class="para">Gingrich, Newt.</p>
<p class="indent-para">    To try men’s souls : a novel of George Washington and the fight for American freedom / Newt Gingrich and William R. Forstchen.——1st ed.</p>
<p class="indent-para">        p. cm.</p>
<p class="indent-para">    ISBN: 978-1-4299-6881-2</p>
<p class="indent-para">1. Washington, George, 1732—1799——Fiction. 2. Paine, Thomas,<br/>1737—1809——Fiction. 3. United States——History——Revolution,<br/>1775—1783——Fiction. I. Forstchen, William R. II. Title.</p>
<p class="indent-para">    PS3557.I4945T6 2009</p>
<p class="indent-para">    813' .54——dc22</p>
<p class="para"> </p>
<p class="right-para1">2009024679</p>
<p class="para"> </p>
<p class="center-para">First Edition: October 2009</p>
<p class="para"> </p>
<p class="center-para">10  9  8  7  6  5  4  3  2  1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?30d58526